export const showFirstLastChar = (address: string, count: number) => {

  const firstSet = address.slice(0, count);
  const secondSet = address.slice(Number(address.length - count), address.length);

  return `${firstSet}...${secondSet}`;
};

export const randomNumber = () => {
  return Math.floor(Math.random() * 100000000);
};